import { Theme } from '@material-ui/core/styles';
import { TableCellClassKey } from '@material-ui/core/TableCell';

const MuiTableCell = (theme: Theme): Partial<Record<TableCellClassKey, unknown>> => ({
    stickyHeader: {
        backgroundColor: theme.palette.background.paper,
    },
});

export default MuiTableCell;
